import React, { Component } from 'react'
import Paper from 'material-ui/Paper'
import Arrow from 'material-ui/svg-icons/hardware/keyboard-arrow-left'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { Container, SloganHeader } from './styles'
import LoginForm from '../../components/LoginForm/LoginForm'
import images from '../../config/images'
import Avatar from '../../components/Avatar/Avatar'
import FooterMenu from '../../components/FooterMenu'
import ForgotPassword from '../../components/ForgotPassword'

const hasLogin = pathname => {
  const substr = 'login'
  return pathname ? pathname.indexOf(substr) !== -1 : false
}

const hasForgotPassword = pathname => {
  const substr = 'forgot-password'
  return pathname ? pathname.indexOf(substr) !== -1 : false
}

class Login extends Component {

  constructor(props) {
    super(props)
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    if (iOS) {
      window.location = `fvwebinar://${(window.location.pathname + window.location.search).substr(1)}`
      setTimeout(() => {
        window.location = 'https://itunes.apple.com/jp/app/workshop-mobile/id1325343868?l=jp&mt=8'
      }, 2000)
      return
    }

    const Android = /android|Android/.test(navigator.userAgent)
    if (Android) {
      window.location = `fvwebinar://${(window.location.pathname + window.location.search).substr(1)}`
      setTimeout(() => {
        window.location = 'https://play.google.com/store/apps/details?id=com.fvwebinar'
      }, 2000)
      return
    }

    var update_flag = true
    if (!(/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor))) {
      window.location = 'https://www.google.com/chrome/browser/desktop/index.html'
      update_flag = false
      return
    }
  }

  componentWillUnmount() {
    this.props.authErrors(null)
  }

  render() {
    return (
      <div className="flex justify-center flex-column items-center h-100">
        <div>
          <div className="mt3 mb4 tc">
            <SloganHeader className="mb3">
              <FormattedMessage
                id="login.heading"/>
            </SloganHeader>
          </div>
          <div className="inline-flex items-center">
            {hasForgotPassword(this.props.location) ? (
              <div className="mr4">
                <Link
                  to={'/login'}
                >
                  <FloatingActionButton>
                    <Arrow/>
                  </FloatingActionButton>
                </Link>
              </div>
            ) : (
              ''
            )}
            <Container
              className={hasForgotPassword(this.props.location) ? 'mr6' : ''}
            >
              <Paper zDepth={3}>
                <div className={`login-layout ${!this.props.shouldResetPassword ? 'pa4' : ''}`}>
                  {hasLogin(this.props.location) &&
                  this.props.errors &&
                  this.props.errors.length >= 1 ? (
                    <div className="tc red">
                      <p>
                        {this.props.errors ===
                        'translation missing: en.invalid_password' ? (
                          <FormattedMessage id="login.invalidPassword"/>
                        ) : this.props.errors ===
                        'translation missing: en.user_not_found' ? (
                          <FormattedMessage id="login.noUser"/>
                        ) : (
                          this.props.errors
                        )}
                      </p>
                    </div>
                  ) : (
                    ''
                  )}
                  {hasLogin(this.props.location) ? (
                    <div>
                      <Avatar src={images.avatar}/>
                      <LoginForm
                        user={this.props.user}
                        authErrors={this.props.authErrors}
                        location={this.props.location}
                        loginUser={this.props.loginUser}
                        logoutRequestResult={this.props.logoutRequestResult}
                        loginStatus={this.props.loginStatus}
                        shouldRedirectUser={this.props.shouldRedirectUser}
                        shouldRedirectUserToLogin={
                          this.props.shouldRedirectUserToLogin
                        }
                      />
                    </div>
                  ) : (
                    <div>
                      {this.props.forgetPassError ? (
                        <div className="tc red">
                          <FormattedMessage id="login.emailNotFound"/>
                        </div>
                      ) : (
                        ''
                      )}
                      <ForgotPassword
                        resetPassword={this.props.resetPassword}
                        location={this.props.location}
                        forgetPassError={this.props.forgetPassError}
                        shouldResetPassword={this.props.shouldResetPassword}
                        setShouldResetPassword={
                          this.props.setShouldResetPassword
                        }
                      />
                    </div>
                  )}
                </div>
              </Paper>
              <FooterMenu/>
            </Container>
          </div>
        </div>
      </div>
    )
  }
}

export default Login




// WEBPACK FOOTER //
// ./src/routes/Login/Login.js